import { render } from "./password-set.vue?vue&type=template&id=67d06fb8&scoped=true&ts=true"
import script from "./password-set.vue?vue&type=script&lang=ts"
export * from "./password-set.vue?vue&type=script&lang=ts"

import "./password-set.vue?vue&type=style&index=0&id=67d06fb8&lang=less&scoped=true"

import exportComponent from "/usr1/jenkins/workspace/FrontEnd_Login_20211011x5/H3Yun_Login/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d06fb8"]])